module.exports = __webpack_public_path__ + "static/media/tw.4ed63792.svg";